
import {Injectable} from "@angular/core";
import { Router } from '@angular/router';
import {Session} from "../models/session.model";
import {User} from "../models/user.model";
import { Token } from "../models/token";

@Injectable()
export class StorageService {

  private localStorageService;
  private currentSession : Session = null;
  private isAdmininistrador:boolean=true;

  constructor(private router: Router) {
    this.localStorageService = localStorage;
    this.currentSession = this.loadSessionData();
  }

  setCurrentSession(session: Session): void {
    this.currentSession = session;
    this.localStorageService.setItem('currentloginUserData', JSON.stringify(session));
  }

  loadSessionData(): Session{
    var sessionStr = this.localStorageService.getItem('currentloginUserData');
    return (sessionStr) ? <Session> JSON.parse(sessionStr) : null;
  }

  getCurrentSession(): Session {
    return this.currentSession;
  }

  removeCurrentSession(): void {
    this.localStorageService.removeItem('currentloginUserData');
    this.currentSession = null;
  }

  getCurrentUser(): User {
    var session: Session = this.getCurrentSession();
    return (session && session.user) ? session.user : null;
  };

  isAuthenticated(): boolean {
    return (this.getCurrentToken() != null) ? true : false;
  };

  getCurrentToken(): string {
    var session = this.getCurrentSession();
    return (session && session.strToken) ? session.strToken : null;
  };

  getToken(): Token {
    var session = this.getCurrentSession();
    return (session && session.token) ? session.token : null;
  };

  getTitulo():string{
    var session: Session = this.getCurrentSession();
    return (session && session.strNombreTitulo) ? session.strNombreTitulo : null;
  }

  getNombre():string{
    var session: Session = this.getCurrentSession();
    return (session && session.strNombre) ? session.strNombre : null;
  }

  /*getMesa():number{
    var session: Session = this.getCurrentSession();
    return (session && session.intMesaId) ? session.intMesaId : null;
  }*/

  /*getToken(): Token {
    var session: Session = this.getCurrentSession();
    return (session && session.token) ? session.token : null;
  };*/

  /*setToken(token:Token){
    this.localStorageService.setItem('currentloginUserData', JSON.stringify(token));
  }

  

  getToken(): Token {
    return this.currentToken;
  }*/

  logout(): void{
    this.removeCurrentSession();
    this.router.navigate(['/login']);
  }

}
